<!--
  Copyright (C) 2022 - Jeci SARL - https://jeci.fr

  This program is free software: you can redistribute it and/or modify
  it under the terms of the GNU Affero General Public License as
  published by the Free Software Foundation, either version 3 of the
  License, or (at your option) any later version.

  This program is distributed in the hope that it will be useful,
  but WITHOUT ANY WARRANTY; without even the implied warranty of
  MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
  GNU Affero General Public License for more details.

  You should have received a copy of the GNU Affero General Public License
  along with this program.  If not, see https://www.gnu.org/licenses/agpl-3.0.html.

-->

<template>
  <div class="layout-menu-container">
    <AppSubmenu
      :items="model"
      class="layout-menu"
      :root="true"
      @menuitem-click="onMenuItemClick"
    />
    <a href="https://pristy.fr" class="block mt-5">
      <img alt="pristy" :src="bannerImage()" class="menu-logo" />
    </a>
  </div>
</template>

<script>
import AppSubmenu from "./AppSubmenu.vue";
import { useConfigStore } from "@pristy/pristy-libvue";

export default {
  name: "AppMenu",
  emits: ["menuitem-click"],
  props: {
    model: Array,
  },
  methods: {
    onMenuItemClick(event) {
      this.$emit("menuitem-click", event);
    },
    bannerImage() {
      const config = useConfigStore();
      return `${config.APP_ROOT}images/pristy/logo-pristy-square.png`;
    },
  },
  computed: {
    darkTheme() {
      return this.$appState.darkTheme;
    },
  },
  components: {
    AppSubmenu,
  },
};
</script>
<style>
img.menu-logo {
  width: 10rem;
  display: block;
  margin-left: auto;
  margin-right: auto;
}
</style>
